import { render } from "./MiinventoryIndex.vue?vue&type=template&id=7639b14e&scoped=true"
import script from "./MiinventoryIndex.vue?vue&type=script&lang=js"
export * from "./MiinventoryIndex.vue?vue&type=script&lang=js"

import "./MiinventoryIndex.vue?vue&type=style&index=0&id=7639b14e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7639b14e"]])

export default __exports__